import { render, staticRenderFns } from "./PharmacistsFavoritesList.vue?vue&type=template&id=2622020e&scoped=true&"
import script from "./PharmacistsFavoritesList.vue?vue&type=script&lang=js&"
export * from "./PharmacistsFavoritesList.vue?vue&type=script&lang=js&"
import style0 from "./PharmacistsFavoritesList.vue?vue&type=style&index=0&id=2622020e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622020e",
  null
  
)

export default component.exports